import { useQuery } from "@tanstack/react-query";
import { ApiGetCustodyOrders } from "@/api";
import type { GetCustodyOrdersResponse } from "@/api/types";
import { getToken } from "@/lib/auth";

/** 仅拉取进行中（type=1）托管主单 */
export function useGetCustodyOrders() {
  return useQuery({
    queryKey: ["custodyOrders", "active"],
    queryFn: async (): Promise<GetCustodyOrdersResponse> => {
      const res = await ApiGetCustodyOrders({ type: 1 });
      return res.data;
    },
    enabled: !!getToken(),
  });
}
